import { render, staticRenderFns } from "./XFamilyTree.vue?vue&type=template&id=344ec0df"
import script from "./XFamilyTree.vue?vue&type=script&lang=js"
export * from "./XFamilyTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports